import axios from 'axios';
import { API_URL } from '../../environment-config';

export interface ICertificateDownloadResponse<_T> {
  data: any;
  status: number;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const downloadCertificate = async (envelopeId: string): Promise<ICertificateDownloadResponse<null>> => {
  const response = await axios.get(`${API_URL}/envelopes/${envelopeId}/auditCertificate`, {
    responseType: 'blob',
  });
  const { data, status } = response;
  return {
    data,
    status,
  };
};
